export const AUTH_MOBILE_PLUGIN_CONFIG_NAME = 'no-edit-auth-mobile';

export const AUTH_PC_PLUGIN_CONFIG_NAME = 'no-edit-auth-pc';
